import Highcharts from 'highcharts';

export const figure12b = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [ 
          "Austria",
          "Bélgica",
          "Bulgaria",
          "Croacia",
          "Chipre",
          "Chequia",
          "Dinamarca",
          "Estonia",
          "Finlandia",
          "Francia",
          "Alemania",
          "Grecia ",
          "Hungría",
          "Irlanda",
          "Italia",
          "Letonia",
          "Lituania",
          "Luxemburgo",
          "Malta",
          "Países Bajos",
          "Polonia ",
          "Portugal",
          "Rumania",
          "Eslovaquia",
          "Eslovenia",
          "España",
          "Suecia",
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 200,
        min: 0,
        tickInterval: 50,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Hombres productores de alimentos en pequeña escala',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 158.3874359, 130.5366523, 50.78005589, 69.24911265, 79.12905649, 63.92729934, 105.7367126, 69.58545007, 109.3822454, 65.30875314, 118.9756479, 77.38812618, 46.32655785, 62.20783477, 132.6547307, 55.24978798, 79.54702445, 107.4600738, 78.05531885, 73.58042581, 59.00599384, 56.16259473, 74.15165422, 80.49176554, 64.93441751, 103.7880984, 99.68319513 ],
      },
      {
        name: 'Mujeres productoras de alimentos en pequeña escala',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 114.9183879, 130.8447485, 49.76590061, 61.54490548, 70.86873136, 53.55213284, 84.6616561, 57.75054116, 87.10532817, 60.80530669, 101.8658914, 74.63223244, 43.56298461, 55.65301618, 128.3741047, 49.35092526, 69.76786211, 82.29845797, 51.09214067, 69.53585777, 52.54771918, 50.0944548, 67.29377423, 73.97423344, 58.40733862, 88.08483775, 73.94415412 ]
      }
    ]
}